import React from 'react';
import PropTypes from 'prop-types';
import { Button } from '@domain-group/fe-co-allhomes-design-system';
import { useSendEvent, withEventBoundary } from '@domain-group/fe-co-allhomes-analytics';
import * as styles from './online-inspections.style';
import { jsx as ___EmotionJSX } from "@emotion/core";
var OnlineInspections = _ref => {
  var agentName = _ref.agentName,
    onContactAgentClick = _ref.onContactAgentClick,
    hasBookingLink = _ref.hasBookingLink;
  var _useSendEvent = useSendEvent(),
    sendEvent = _useSendEvent.sendEvent;
  var handleContactAgentClick = () => {
    sendEvent('email-click');
    onContactAgentClick();
  };
  return ___EmotionJSX("div", {
    css: styles.onlineInspections
  }, ___EmotionJSX("div", {
    css: styles.heading
  }, "Can't inspect in person?"), ___EmotionJSX("p", {
    css: styles.body
  }, "Contact ", agentName, " to enquire about this property including alternatives to in-person inspections."), ___EmotionJSX(Button, {
    onClick: handleContactAgentClick,
    css: styles.button,
    appearance: hasBookingLink ? 'secondaryNeutral' : 'primary',
    size: "standard"
  }, "Contact agent"));
};
OnlineInspections.propTypes = {
  agentName: PropTypes.string,
  hasBookingLink: PropTypes.bool,
  onContactAgentClick: PropTypes.func
};
OnlineInspections.defaultProps = {
  agentName: 'the agent',
  hasBookingLink: false,
  onContactAgentClick: () => {}
};
export default withEventBoundary('online-inspections')(OnlineInspections);